import React from "react";

export const WA_BENEFITS = [
  {
    label: "Sending messages from your brand name",
    checked: true,
  },
  {
    label: "Respond to unlimited customer initiated conversations",
    checked: true,
  },
];

export const WA_UNLOCKING_KEY_DETAILS = [
  {
    id: 1,
    label: (
      <>
        <strong>Meta Business Account required</strong>: You need to set up a
        FBM account which requires verification of your company information.
      </>
    ),
  },
  {
    id: 2,
    label: (
      <>
        <strong>Phone number verification</strong>: Provide a number that can be
        verified by WhatsApp and cannot be currently used on any other WhatsApp
        app.
      </>
    ),
  },
];

export const FEATURE_SECTIONS_STEPS = [
  {
    id: 1,
    label: "Create your Own Brand ✨",
    info: "Remove ‘powered by Exly’ branding from all your end-user pages. Also, customise your customer invoices.",
  },
  {
    id: 2,
    label: "Fully Customizable Footer 🪄",
    info: "Customize your home page and thank you page footers for your needs. Add or remove and manage your back links.",
  },
  {
    id: 3,
    label: "Got different Email sender IDs? 📣",
    info: "Engage your audience and nurture leads by broadcasting emails and setting up drips using different sender email IDs.",
  },
];
